import React from 'react';
import Layout from '@rezdy/components/Layout/DarkCentered';
import { Article, Aside, Body } from '@rezdy/components/Layout/Article/Styled';
import SecondaryAction from '../../components/SignUpV2/SecondaryAction';
import { SignUpCard } from '../../components/SignUpV2/SignupCard';
import VerifyEmailSuccess from '../../components/SignUpV2/VerifyEmailSuccess';
import VerifyEmailError from '../../components/SignUpV2/VerifyEmailError';
import VerifyEmailExpiredLink from '../../components/SignUpV2/VerifyEmailExpiredLink';
import Grid from '@rezdy/components/Grid';
import TextStyle from '@rezdy/components/TextStyle';
import { H4 } from '@rezdy/components/Heading';
import Icon from '@rezdy/components/Icon';
import queryString from '../../services/queryString';
import routing from '../../services/routing';
import verifyEmail from '../../actions/verifyEmail';
import { withTranslation, WithTranslation } from 'react-i18next';
import { EMAIL_VERIFIED, EXPIRED_REFRESH_TOKEN, INVALID_ENTITY } from '../../constants/actions';
import EmailVerified from '../../components/SignUpV2/EmailVerified';

export class EmailVerification extends React.Component<WithTranslation> {
    state = {
        loading: true,
        emailVerification: '',
        username: '',
    };

    async componentDidMount() {
        const params = queryString.parse(routing.location.search);
        const username = decodeURIComponent((params.username as string) || '');
        const code = decodeURIComponent((params.code as string) || '');
        const emailVerification = await verifyEmail({
            username,
            code,
        });
        this.setState({
            emailVerification,
            username,
            loading: false,
        });
    }

    renderLoading = () => {
        const { i18n } = this.props;
        return (
            <TextStyle align="center">
                <H4>
                    {i18n.t('emailVerification.heading')}
                    <Icon name="loader-dots" size="large" />
                </H4>
            </TextStyle>
        );
    };

    renderEmailVerification = (responseType: string) => {
        if (this.state.loading) {
            return this.renderLoading();
        }

        switch (responseType) {
            case EMAIL_VERIFIED:
                return <VerifyEmailSuccess />;
            case EXPIRED_REFRESH_TOKEN:
                return <VerifyEmailExpiredLink username={this.state.username} />;
            case INVALID_ENTITY:
                return <EmailVerified />;
            default:
                return <VerifyEmailError />;
        }
    };

    render(): React.ReactNode {
        return (
            <Layout secondaryAction={<SecondaryAction />}>
                <Article style={{ alignItems: this.state.loading ? 'center' : 'start' }}>
                    <Body>
                        <Grid.Container rowGap="24px" style={{ maxWidth: 400 }}>
                            {this.renderEmailVerification(this.state.emailVerification)}
                        </Grid.Container>
                    </Body>
                    <Aside>
                        <SignUpCard />
                    </Aside>
                </Article>
            </Layout>
        );
    }
}

export default withTranslation()(EmailVerification);
